import { useTranslation } from 'react-i18next'
import SectionCard from '../shared/SectionCard'
import './style.css'
import TextArea from '@/components/formFields/TextArea'
import InputField from '@/components/formFields/InputField'

const EditRefundPolicy = ({ formHandler, providerInfo }) => {
    const { t } = useTranslation()

    return (
        <SectionCard
            title={t("refund-policy-header")}
            icon="ri:refund-2-fill"
            className="edit-refund-policy"
        >
            <div >
                <InputField
                    isLoading={false}
                    type="number"
                    min={"1"}
                    className="col-lg-6"
                    label={t("refundPolicyAmount")}
                    formHandler={formHandler}
                    name={"refundPolicyAmount"}
                    defaultValue={providerInfo?.refundPercentage}
                />
            </div>
            <div className="row col-lg-12">
                <TextArea
                    className="col-lg-6"
                    formHandler={formHandler}
                    name="refund-policy"
                    setValue={(value) => formHandler.handleFormValues('refundPolicy', value)}
                    label={t("refund-policy")}
                    placeholder={t("enter-refund-policy")}
                    value={formHandler?.formValues?.refundPolicy}
                    defaultValue={providerInfo?.refundPolicy}
                />
                <TextArea
                    className="col-lg-6"
                    formHandler={formHandler}
                    lang="En"
                    name="refundPolicyEN"
                    setValue={(value) => formHandler.handleFormValues('refundPolicyEN', value)}
                    label={t("refund-policyEN")}
                    placeholder={t("enter-refund-policyEN")}
                    value={formHandler?.formValues?.refundPolicyEN}
                    defaultValue={providerInfo?.refundPolicyEN}
                />
            </div>

        </SectionCard>
    )
}

export default EditRefundPolicy

